<template>
  <br><div class="contenedor-botones">
  <v-btn class="mx-2 gris_medio" @click="exportToCSV">
                   {{$t('general.exportar')}}<span class="material-symbols-outlined">arrow_outward</span>
                </v-btn>
                <v-btn  class="mx-2 gris_medio" @click="importFromCSV">
                 <span class="material-symbols-outlined">arrow_insert</span>  {{$t('general.importar')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleUpload"
                  />
                </v-btn>
 </div>

 <div class="contenedor-tabla"><br>
   <!-- <h3 class="table-header">{{ labels.titulo }}</h3> -->
   <div class="scroll-container">
     <table>
       <thead>
         <tr>
           <th class="encabezado columna_sticky " > {{ labels.horizonte }}</th>
           <th class="encabezado" > {{ labels.hora }}</th>
           <th class="encabezado"  v-for="motor in motoresCogeneracion" :key="motor">
             {{ abreviarMotor(motor) }}
           </th>
         </tr>
       </thead>
       <tbody>
         <tr v-for="(row, index) in disponibilidadLocal" :key="index" class="tabla-hover">
           <td class="horizonte primera_columna columna_sticky">{{ row.horizonte }}</td>
           <td class="hora primera_columna" style="text-align: center !important;">{{ row.hora }}</td>
           <td  v-for="motor in motoresCogeneracion" :key="motor">
             <select class="gris_medio" v-model.number="row.disponibilidad[motor]" @change="emitChanges">
               <option value="1">1</option>
               <option value="0">0</option>
             </select>
           </td>
         </tr>
       </tbody>
     </table>
   </div>
 </div>
</template>

<script>
//import Papa from "papaparse";
import Swal from "sweetalert2";

export default {
 props: {
   modelValue: {
     type: Array,
     default: () => [],
     required: true
   },
   horizonte: {
     type: Number,
     required: true
   }
 },
 data() {
   return {
     motoresCogeneracion: [
       "Motor cogeneración 1",
       "Motor cogeneración 2",
       "Motor cogeneración 3",
       "Motor cogeneración 4",
       "Motor cogeneración 5",
       "Motor cogeneración 6",
       "Motor cogeneración 7",
       "Motor cogeneración 8"
     ],
     labels: {
       titulo: this.$t("disponibilidad.disponibilidad_cogeneracion"),
       horizonte: this.$t("disponibilidad.cogeneracion.horizonte"),
       hora: this.$t("disponibilidad.cogeneracion.hora")
     }
   };
 },
 computed: {
  disponibilidadLocal: {
    get() {
      return this.modelValue.length
        ? this.modelValue.map(row => ({
            ...row,
            horizonte: this.formatHorizonte(row.horizonte) // Asegurar formato antes de mostrar
          }))
        : [];
    },
    set(value) {
      this.$emit("update:modelValue", value);
    }
  }
 },
 methods: {
   abreviarMotor(nombre) {
    // Reemplaza "Motor cogeneración 1" por "Motor Cog. 1"
    return nombre.replace("Motor cogeneración", "Motor Cog.");
  },
   emitChanges() {
   
   this.$emit("update:modelValue", this.disponibilidadLocal);
   },
  
  formatHorizonte(value) {
    if (!value) return "";

    // Reemplazar "/" por "-"
    let formatted = value.replace(/\//g, "-");

    // Separar fecha y hora si existen
    let dateTimeParts = formatted.split(" ");
    let datePart = dateTimeParts[0];
    let timePart = dateTimeParts[1] || "00:00"; // Si no hay hora, asumir "00:00"

    // Separar fecha en partes
    let parts = datePart.split("-");
    
    // Si tiene tres partes (día, mes, año), aseguramos el formato correcto
    if (parts.length === 3) {
      let year, month, day;

      if (parts[0].length === 4) {
        // Si la primera parte es el año (correcto: YYYY-MM-DD)
        year = parts[0];
        month = parts[1].padStart(2, "0");
        day = parts[2].padStart(2, "0");
      } else {
        // Si la primera parte es el día (incorrecto: DD-MM-YYYY o DD-MM-YY)
        day = parts[0].padStart(2, "0");
        month = parts[1].padStart(2, "0");
        year = parts[2].length === 2 ? `20${parts[2]}` : parts[2]; // Convertir YY a YYYY si es necesario
      }

      return `${year}-${month}-${day} ${timePart}`;
    }

    return formatted;
  },


   // Exportar a CSV
   exportToCSV() {
     const headers = ["Horizonte", "Hora", ...this.motoresCogeneracion].join(";");
     const rows = this.disponibilidadLocal.map((row) =>
       [
         this.formatHorizonte(row.horizonte),
         row.hora,
         ...this.motoresCogeneracion.map((motor) => row.disponibilidad[motor])
       ].join(";")
     );

     const csvContent = [headers, ...rows].join("\n");
     const BOM = "\uFEFF";
     const blob = new Blob([BOM + csvContent], { type: "text/csv;charset=utf-8;" });
     const url = URL.createObjectURL(blob);
     const a = document.createElement("a");
     a.href = url;
     a.download = "disponibilidad_motores_cogeneracion.csv";
     a.click();
     URL.revokeObjectURL(url);
   },

   // Importar desde CSV
   importFromCSV() {
     this.$refs.fileInput.click();
   },

   // Manejar la subida del archivo CSV
    guess_delimiter(h) { return h.split(",").length > h.split(";").length ? "," : ";"; },

    // Helper 0/1 estrictos
parseBinarioEstricto(raw) {
  const s = String(raw ?? '').trim();
  if (s === '') return { ok:false, motivo:'vacío' };
  const n = Number(s.replace(',', '.'));
  if (!Number.isFinite(n)) return { ok:false, motivo:'no-numérico' };
  if (!(n === 0 || n === 1)) return { ok:false, motivo:'fuera-rango' };
  return { ok:true, val:n };
},

handleUpload(event) {
  const file = event.target.files[0];
  if (!file) return;

  if (!/\.csv$/i.test(file.name)) {
    Swal.fire({ icon: 'error', title: 'Formato no válido', text: 'Solo se admiten archivos .csv.' });
    event.target.value = '';
    return;
  }

  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const content = e.target.result;
      const lines = String(content).replace(/\r\n/g, '\n').split('\n').filter(Boolean);
      if (lines.length < 2) throw new Error('El CSV está vacío.');

      // ====== CABECERAS: faltantes / sobrantes / desordenadas ======
      const HEADERS_OFICIALES = ['Horizonte', 'Hora', ...this.motoresCogeneracion];

      let headers = lines[0]
        .split(';')
        .map((h, i) => (i === 0 ? String(h).replace(/^\uFEFF/, '') : String(h)).trim());

      const faltantes = HEADERS_OFICIALES.filter(h => !headers.includes(h));
      const extrasRaw = headers.filter(h => !HEADERS_OFICIALES.includes(h));
      const extras = extrasRaw.map(x => String(x).trim()).filter(Boolean);

      let desordenadas = [];
      if (faltantes.length === 0 && extras.length === 0) {
        HEADERS_OFICIALES.forEach((h, i) => {
          if (headers[i] !== h) desordenadas.push(`${h} (posición esperada ${i + 1})`);
        });
      }

      const seccion = (titulo, arr) => {
        const items = (arr || []).map(x => String(x).trim()).filter(Boolean);
        return items.length
          ? `<h4 style="margin:6px 0 2px 0;">${titulo}</h4>
             <ul style="margin:0 0 8px 18px; padding:0;">${items.map(x => `<li>${x}</li>`).join('')}</ul>`
          : '';
      };

      if (faltantes.length || extras.length || desordenadas.length) {
        const html =
          `<div style="text-align:left;">
             <p>El CSV no respeta la <b>plantilla oficial</b> (encabezados y orden).</p>
             ${seccion('❌ Faltan', faltantes)}
             ${seccion('⚠️ Sobran', extras)}
             ${seccion('🔄 Desordenadas', desordenadas)}
             <p style="margin-top:6px;"><small>
               Consejo: exporta la plantilla oficial y copia tus datos respetando los encabezados y su orden.
             </small></p>
           </div>`;
        Swal.fire({ icon: 'error', title: 'Encabezados incorrectos', html, width: 800 });
        event.target.value = '';
        return;
      }
      // ====== FIN CABECERAS ======

       /* Comprobación filas-horizonte
      const expectedRows = (Number.isFinite(this.horizonte) && this.horizonte > 0)
        ? this.horizonte * 24
        : null;

      // Cuenta SOLO filas de datos (excluye cabecera y ignora líneas totalmente vacías)
      const dataLines = lines
        .slice(1)
        .filter(l => l.split(';').some(c => String(c).trim() !== ''));

      if (expectedRows !== null && dataLines.length !== expectedRows) {
        Swal.fire({
          icon: 'error',
          title: 'Número de filas incorrecto',
          html: `Se esperaban ${expectedRows}</b> filas y se recibieron ${dataLines.length}.`,
          
        });
        event.target.value = '';
        return;
      }*/

      const IDX = { horizonte: 0, hora: 1 };
      const celdasVacias = [];
      const erroresMotores = [];
      const nuevos = [];

      const raw = (arr, i) => String(arr[i] ?? '').trim();

      for (let i = 1; i < lines.length; i++) {
        const cols = lines[i].split(';');

        // Saltar fila totalmente vacía (posible línea final)
        if (cols.every(c => String(c).trim() === '')) continue;

        if (cols.length !== HEADERS_OFICIALES.length) {
          throw new Error(`Fila ${i + 1}: número de columnas inválido (${cols.length}).`);
        }

        const rowNumber = i + 1;
        const horizonteRaw = raw(cols, IDX.horizonte);
        const horaRaw = raw(cols, IDX.hora);

        if (!horizonteRaw) celdasVacias.push(`L${rowNumber}: Horizonte vacío`);
        if (!horaRaw) celdasVacias.push(`L${rowNumber}: Hora vacía`);

        const disp = {};
        this.motoresCogeneracion.forEach((motor, k) => {
          const idx = 2 + k;
          const valRaw = raw(cols, idx);
          if (valRaw === '') celdasVacias.push(`L${rowNumber}: ${motor} vacío`);

          const parsed = this.parseBinarioEstricto(valRaw);
          if (!parsed.ok) {
            erroresMotores.push(
              `L${rowNumber}: ${motor}="${valRaw}"${
                parsed.motivo === 'no-numérico' ? ' (no numérico)' :
                parsed.motivo === 'fuera-rango' ? ' (solo 0 o 1)' : ' (vacío)'
              }`
            );
          } else {
            disp[motor] = parsed.val;
          }
        });

        nuevos.push({
          horizonte: this.formatHorizonte(horizonteRaw), // normaliza formato si quieres
          hora: horaRaw,
          disponibilidad: disp
        });
      }

      if (celdasVacias.length || erroresMotores.length) {
        const bloques = [];
        if (celdasVacias.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Celdas obligatorias vacías</h4>
             <div style="max-height:35vh;overflow:auto;text-align:left">
               ${celdasVacias.slice(0, 400).join('<br>')}${celdasVacias.length > 400 ? '…' : ''}
             </div>`
          );
        }
        if (erroresMotores.length) {
          bloques.push(
            `<h4 style="margin:8px 0 4px 0;">Valores inválidos en disponibilidad (solo 0 o 1)</h4>
             <div style="max-height:35vh;overflow:auto;text-align:left">
               ${erroresMotores.slice(0, 400).join('<br>')}${erroresMotores.length > 400 ? '…' : ''}
             </div>`
          );
        }

        Swal.fire({ icon:'error', title:'Errores en datos', html:bloques.join('<br>'), width:900 });
        event.target.value = '';
        return;
      }

      // Todo correcto → importar todo
      this.disponibilidadLocal = nuevos; // usa el setter del computed
      Swal.fire({ icon:'success', title:'Importación correcta', text:`${nuevos.length} filas importadas.` });
    } catch (err) {
      Swal.fire({ icon:'error', title:'Error al importar', text: err?.message ?? 'Archivo no válido.' });
    } finally {
      event.target.value = ''; // limpia el input
    }
  };

  reader.readAsText(file, 'utf-8');
}


 }
};
</script>

<style scoped>
/* Estilos */
table {
 width: 100%;
 border-collapse: collapse;
 text-align: center;
}
.scroll-container {
 width: 100%;
 height: 100%;
 max-height: calc(100vh - 200px); 
 overflow-x: auto;
 overflow-y: auto;
 border-radius: 10px;
 display: flex;
 flex-direction: column;
}
.table-header {
 font-size: 1.5em;
 font-weight: bold;
 text-align: center;
 margin-bottom: 10px;
 color: white;
 background-color: #686868;
 border-radius: 10px;
 padding: 5px;
}
thead {
   position: sticky;
   top: 0;
   background-color: white;
   z-index: 10;
 }

.horizonte, .hora {
 background-color: white;
}
.horizonte{
 width: 150px;
}
/* td {
 font-weight: bold;
 color: #024e74;
 border: 2px solid #D9D9D9;
 padding: 10px;
 background-color: #F2F2F2;
} */
select {
 width: 100%;
 border-radius: 4px;
 text-align: center;
 color: #024e74;
 padding: 5px;
}
</style>